import type { GlobalAssistantContextPolicy } from './global-ai-assistant-api';
import type { GlobalAssistantBoundedConversationContext } from './global-ai-assistant-conversation';

const CONTEXT_POLICY_DEPENDENT_PROMPT_RE =
  /\b(it|that|those|them|this|same|again|over time|continue)\b/i;

export function toConversationPayload(
  context: GlobalAssistantBoundedConversationContext
):
  | {
      turns: GlobalAssistantBoundedConversationContext['turns'];
      summary?: string;
    }
  | undefined {
  if (context.turns.length === 0 && !context.summary) {
    return undefined;
  }
  return {
    turns: context.turns,
    ...(context.summary ? { summary: context.summary } : {}),
  };
}

export function applyConversationPolicy(args: {
  policy: GlobalAssistantContextPolicy;
  fullConversation: GlobalAssistantBoundedConversationContext;
}): GlobalAssistantBoundedConversationContext {
  const { policy, fullConversation } = args;
  if (policy === 'recent_only') {
    return { turns: fullConversation.turns };
  }
  if (policy === 'none') {
    return { turns: [] };
  }
  return fullConversation;
}

function isPromptPronounDependent(prompt: string): boolean {
  const trimmed = prompt.trim();
  if (!trimmed) {
    return false;
  }
  const tokens = trimmed.split(/\s+/).filter(Boolean);
  if (tokens.length > 8) {
    return false;
  }
  return CONTEXT_POLICY_DEPENDENT_PROMPT_RE.test(trimmed);
}

export function resolveFollowOnContextPolicy(
  requestedPolicy: GlobalAssistantContextPolicy | undefined,
  prompt: string
): GlobalAssistantContextPolicy {
  if (
    requestedPolicy !== 'full' &&
    requestedPolicy !== 'recent_only' &&
    requestedPolicy !== 'none'
  ) {
    return 'full';
  }
  if (requestedPolicy === 'none' && isPromptPronounDependent(prompt)) {
    return 'recent_only';
  }
  return requestedPolicy;
}
